import { Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LangProvider } from '@/context/LangProvider';
import '@/css/scrollbar.css';
import '@/css/productlane.css';
import Error404Page from '@/pages/error/Error404Page';
import Routes from '@/router/routes';
import useAuthStore from '@/store/AuthStore';
import useErrorStore from '@/store/ErrorStore';
import { useFetchUser } from '@/hooks/useUser';
import { useProductlaneWidget } from '@/hooks/useProductlaneWidget';
import AuthContent from './AuthContent';
import { NetworkStatusProvider } from '@/components/NetworkStatusProvider';

function AuthWrapper() {
  const location = useLocation();
  const { authToken } = useAuthStore();
  const { showError } = useErrorStore();

  useFetchUser();
  useProductlaneWidget();
  if (showError) return <Error404Page />;

  return authToken ? (
    <LangProvider>
      <NetworkStatusProvider>
        <AuthContent />
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{
            zIndex: 99999999999,
            width: 'auto',
            minWidth: '340px',
            maxWidth: '520px',
            fontSize: '0.875rem',
          }}
        />
      </NetworkStatusProvider>
    </LangProvider>
  ) : (
    <Navigate to={Routes.login.path} state={{ from: location.pathname }} replace />
  );
}

export default AuthWrapper;
